<template>
	<div>
		<div v-for="item in projNow" :key="item.id">
			<!-- Title page -->
            <div>
                <div class="title-img">
                    <img :src="require('../../assets/designProjects/' + item.img)">
                    <div class="title-img-overlay"></div>
                </div>
                <b-container fluid class="title-des">
                    <b-col class="col-lg-3 col-md-4 col-sm-6">
                        <h1 class="text-info text-left">{{ item.title }}</h1>
                        <p class="text-white">{{ item.description }}</p>
                    </b-col>
                </b-container>
            </div>
            <!-- Header -->
            <Header></Header>
            <!-- Project Info -->
            <b-container class="d-none d-lg-block d-xl-block content-left">
                <b-col class="col-lg-2">
                    <div class="my-5">    
                        <h5 class="text-info">Type</h5>
                        <p>{{ item.type }} <br>{{ item.skill }}</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Duration</h5>
                        <p>{{ item.time }} <br>{{ item.duration }}</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Team</h5>
                        <p>Akari Takada</p>
                    </div>
                    <!-- <div class="my-5">
                        <h5 class="text-info">Skills</h5>
                        <p>edit here</p>
                    </div> -->
                </b-col>
            </b-container>
			<!-- Overview -->
            <b-container class="my-5">
                <h2 class="my-4 text-light">Overview</h2>
                <b-col class="my-5 col-lg-9 col-md-12 col-sm-12 mx-auto">
                    <b-row class="align-items-center">
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Context</h5>
                            <h3>Redesigning the SodaStream.</h3>
                            <p>A sodaStream is a product that allows users to make carbonated water and drinks from the comfort of their homes. It consists of the bottle, CO2 canister, and machine.</p>
                        </b-col>
                        <b-col md class="my-2 px-0">
                            <div>
                                <img class="rounded-img" src="../../assets/designProjects/sodastream/product.png" alt="">
                                <p class="text-right w-100"><small>Source: SodaStream</small></p>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-container>
			<!-- Problem -->
            <b-container class="bg-custom py-5 my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Focus</h5>
							<h3>Targeting health seekers.</h3>
							<p>sodaStream users like to drink carbonated water as an equally refreshing but healthier alternative to soda. It also supports a sustainable lifestyle that reduces use of one-time plastics.</p>
                        </b-col>
                    </b-row>
					<b-row class="my-2">
                        <img class="rounded-img" src="../../assets/designProjects/sodastream/context-collage.png" alt="">
                    </b-row>
                </b-col>
            </b-container>
            <b-container class="bg-problem py-5 my-5">
                <h3 class="text-white m-0">Design a sodaStream that makes health seekers feel "calm" and "confident".</h3>
            </b-container>
			<!-- Solution -->
            <b-container class="my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Solution</h5>
                            <h3>SODAX.</h3>
							<p>A sodaStream redesign that induces "calm confidence".</p>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="banner">
                        <div>
                            <img class="rounded-img" src="../../assets/designProjects/sodastream/sodastream-hero.png" alt="">
                            <div class="banner-img-overlay"></div>
                        </div>
                        <div class="banner-des w-430">
                            <h4 class="text-white">Stable, empowering form.</h4>
                            <p class="text-white">Sharp, bold lines and upward sense of direction, as well as the low center of gravity portrays "confidence".</p>
                        </div>
                    </b-row>
                </b-col>
				<b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
					<b-row class="align-items-center">
						<b-col md class="my-2">
							<div>
								<h4>Minimal, natural colors.</h4>
								<p>The stone texture, stainless steel, and glass all have similar natural textures and tones that contribute to the "calm" feeling.</p>
							</div>
						</b-col>
						<b-col md class="my-2 p-0">
							<div>
								<img class="rounded-img" src="../../assets/designProjects/sodastream/natural.png" alt="">
							</div>
						</b-col>
					</b-row>
					<b-row class="align-items-center my-2 mt-xl-2 mt-lg-2 mt-md-2 mt-sm-5">
						<b-col md class="my-2">
							<div>
								<h4>Balancing the form with organic lines.</h4>
								<p>The organic lines and assymetry adds a lovable character to the sodaStream.</p>
							</div>
						</b-col>
						<b-col md class="my-2 p-0">
							<div>
								<img class="rounded-img" src="../../assets/designProjects/sodastream/organic.png" alt="">
							</div>
						</b-col>
					</b-row>
				</b-col>
				<b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="banner">
                        <div>
                            <img class="rounded-img" src="../../assets/designProjects/sodastream/components.png" alt="">
                            <div class="banner-img-overlay"></div>
                        </div>
                        <div class="banner-des w-430">
                            <h4 class="text-white">Form that emphasizes functionality.</h4>
                            <p class="text-white">The placement and orientation of the CO2 canister clarifies the heirarchy and identity of each component.</p>
                        </div>
                    </b-row>
                </b-col>
				<b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h4>Unconventional yet recognizable.</h4>
							<p>According to the MAYA principle, products that are most-advanced-yet-acceptable are the most desireable. SodaX falls in the sweet-spot when compared to other products.</p>
						</b-col>
                    </b-row>
                    <b-row class="my-2">
                        <img class="rounded-img" src="../../assets/designProjects/sodastream/MAYA.png" alt="">
                    </b-row>
                </b-col>
			</b-container>
		</div>
		<footerProjects></footerProjects>
	</div>
</template>

<script>
import csvData from '../../data/designProjectInfo.csv'
const Header = () => import('../../components/Header.vue')
const footerProjects = () => import('../../components/footerProjects.vue')


  var now = 'sodastream';

  export default {
    name: 'sodastream',
    title: 'Sodastream',
    components: {
      'Header': Header,
      'footerProjects': footerProjects,
    },
    data: () => {
      return {
        items : csvData
      }
    },
    computed: {
      projNow() {
        return this[this.$i18n.locale].filter((item) => item.code == now);
      },
      ja() {
        return this.items.filter((item) => item.lang == 'ja' );
      },
      en() {
        return this.items.filter((item) => item.lang == 'en');
      },
      path() {
        return this.item.path;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="@/scss/designProjects.scss">
</style>